import actions from './actions';
import types from './mutation-types';

const state = {
    autocomplete: {
        error: null,
        isFetching: false,
        data: []
    }
};

const getters = {
    autocompletePersons: state => state.autocomplete.data,
    autocompleteIsFetching: state => state.autocomplete.isFetching
};

const mutations = {
    [types.FETCH_AUTOCOMPLETE_START](state) {
        state.autocomplete.isFetching = true;
	},
    [types.FETCH_AUTOCOMPLETE_ERROR](state, error) {
        state.autocomplete.isFetching = false;
        state.autocomplete.error = error;
	},
    [types.FETCH_AUTOCOMPLETE_SUCCESS](state, data) {
        state.autocomplete.isFetching = false;
        state.autocomplete.error = null;
        state.autocomplete.data = data;
	}
};

export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/person/index.js